"use client"

import { ImageLoader } from '@/components/ui/image-loader'
import { ERROR_IMAGE } from '@/lib/constant'
import { useRouter } from 'next/navigation'

export default function Page() {
    const router = useRouter()
    return (
        <div className='h-screen w-full flex flex-col gap-6 justify-center items-center bg-white'>
            <div className='h-96 w-full relative rounded-full  flex flex-col justify-center items-start'>
                <ImageLoader src={ERROR_IMAGE} alt='Error Img' fill className='object-contain' />
            </div>
            <button onClick={() => router.replace('/')} >
                <div className='primary-btn px-8 group/primary-btn h-fit w-fit shrink-0'>
                    <span className='h-full w-full bg-custom-primary absolute top-0 left-0 group-hover/primary-btn:scale-y-[0.7] group-hover/primary-btn:scale-x-90 transition rounded-sm group-hover:rounded' />
                    <div className='flex items-center gap-2 text-nowrap relative'>
                        Back to Home
                    </div>
                </div>
            </button>
        </div>
    )
}